import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BACriminologyCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. Criminology",
    shortName: "B.A. Criminology",
    duration: "3 years",
    description: "Study of crime, criminal behavior, and criminal justice system",
    overview: "Bachelor of Arts in Criminology is a 3-year undergraduate program that examines the nature of crime, causes of criminal behavior, and the criminal justice system. This interdisciplinary course combines sociology, psychology, law, and forensic science to understand crime patterns and develop effective crime prevention strategies, preparing students for careers in law enforcement, criminal justice, and social work.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Interest in criminal justice and law enforcement",
      "Good analytical and observation skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Introduction to Criminology",
          "Criminal Law",
          "Psychology",
          "Sociology",
          "General English",
          "Statistics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Theories of Crime",
          "Criminal Investigation",
          "Forensic Science",
          "Victimology",
          "Juvenile Delinquency",
          "Research Methods"
        ]
      },
      {
        year: 3,
        subjects: [
          "Penology and Corrections",
          "White Collar Crime",
          "Cyber Crime",
          "Criminal Psychology",
          "Crime Prevention",
          "Field Work and Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Police Officer",
        "Criminal Investigator",
        "Forensic Analyst",
        "Probation Officer",
        "Crime Scene Investigator",
        "Security Consultant",
        "Legal Advisor",
        "Social Worker",
        "Research Analyst",
        "Policy Analyst"
      ],
      industries: [
        "Law Enforcement Agencies",
        "Forensic Laboratories",
        "Criminal Justice System",
        "Private Security Firms",
        "Legal Consulting",
        "Government Departments",
        "NGOs and Social Organizations",
        "Research Institutions",
        "Corporate Security",
        "International Organizations"
      ],
      averageSalary: "₹3-7 LPA (Fresher), ₹10-22 LPA (Experienced)",
      topRecruiters: [
        "State Police Departments",
        "CBI, NCB, ED",
        "Forensic Science Labs",
        "Private Security Companies",
        "Legal Firms",
        "NGOs in Criminal Justice"
      ]
    },

    admissionProcess: [
      "Merit-based admission on 12th marks",
      "Entrance tests in some universities",
      "Interview and aptitude test",
      "Physical fitness test (for some roles)",
      "Background verification"
    ],

    topColleges: [
      {
        name: "Tamil Nadu Dr. Ambedkar Law University",
        location: "Chennai",
        fees: "₹35,000",
        ranking: "Specialized Law University"
      },
      {
        name: "University of Madras",
        location: "Chennai",
        fees: "₹28,000",
        ranking: "State University"
      },
      {
        name: "Bharathidasan University",
        location: "Tiruchirappalli",
        fees: "₹30,000",
        ranking: "State University"
      },
      {
        name: "Annamalai University",
        location: "Chidambaram",
        fees: "₹32,000",
        ranking: "State University"
      }
    ],

    skills: [
      "Criminal Investigation",
      "Forensic Analysis",
      "Legal Research",
      "Critical Thinking",
      "Report Writing",
      "Interview Techniques",
      "Data Analysis",
      "Crime Scene Analysis",
      "Case Study Methods",
      "Ethical Reasoning"
    ],

    futureScope: "Growing demand for criminologists in cyber crime investigation, corporate security, forensic consulting, and criminal justice reform with increasing focus on crime prevention and digital forensics.",

    faqs: [
      {
        question: "What career opportunities are available in law enforcement?",
        answer: "Graduates can join police services, CBI, forensic departments, crime investigation units, and specialized agencies dealing with cyber crime and economic offenses."
      },
      {
        question: "Can I pursue higher studies after B.A. Criminology?",
        answer: "Yes, students can pursue M.A. Criminology, LL.B., M.Sc. Forensic Science, or specialized diplomas in investigation and security management."
      },
      {
        question: "Is physical fitness important for this career?",
        answer: "Physical fitness is important for field work and law enforcement roles, but many criminology careers like research, analysis, and consulting focus more on analytical skills."
      },
      {
        question: "What is the scope in private sector?",
        answer: "Private sector opportunities include corporate security, fraud investigation, risk assessment, security consulting, and compliance roles in banks and financial institutions."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BACriminologyCoursePage;
